export default "__VITE_ASSET__BZtroaxN__"